module.exports = __webpack_public_path__ + "fonts/iconfont.7abee731.ttf";